export default __webpack_public_path__ + "static/media/consciencia.43caffd0.png";